import { useExplorer } from "@/context/ExplorerContext";
import { ImageSlot } from "@/components/lurio/ImageSlot";
import { Eyebrow, Hand, Section, CTA, Fr } from "@/components/lurio/Primitives";
import { Reveal } from "@/components/lurio/Motion";

export default function MeetNori() {
  const { t } = useExplorer();
  const rot = [-3, 2, -2];
  return (
    <Section id="nori" bg="bg-gold" className="overflow-hidden text-ink">
      <div className="grid items-center gap-14 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow tone="text-ink/70" className="mb-5">{t.nori.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-4xl font-bold leading-[1.3] sm:leading-[1.3] lg:leading-[1.3] text-ink sm:text-5xl">{t.nori.title}</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-lg text-[1.08rem] leading-[1.85] text-ink/80 sm:text-lg">{t.nori.body}</p>
          </Reveal>
          <Reveal delay={0.15} className="paper-card grain relative mt-10 max-w-lg rotate-[1deg] p-7">
            <p className="eyebrow">{t.nori.promiseTitle}</p>
            <blockquote className="mt-3 font-serif text-[1.4rem] leading-[1.6] text-ink">{t.nori.promise}</blockquote>
            <Hand className="mt-3 text-2xl" rotate={3}><Fr>{t.nori.signature}</Fr></Hand>
          </Reveal>
          <Reveal delay={0.2} className="mt-8">
            <CTA testId="nori-cta-button" label="كوموندي دابا" />
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <ul data-testid="nori-poses" className="grid grid-cols-3 gap-3 sm:gap-5">
            {t.nori.poses.map((p, i) => (
              <Reveal as="li" key={p.id} delay={0.08 * i} className="flex flex-col items-center text-center">
                <div className={`sticker peel w-full rounded-[28px] bg-cream p-3 sm:p-4`} style={{ transform: `rotate(${rot[i]}deg)` }}>
                  <ImageSlot id={`nori_${p.id}`} fit="contain" rounded="rounded-none" />
                </div>
                <Fr className="mt-4 text-[0.8rem] font-bold text-ink/70 sm:text-sm">{p.printed}</Fr>
                <span className="font-hand text-2xl leading-none text-blue sm:text-3xl">{p.da}</span>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.25}>
            <p className="mt-6 text-center text-sm text-ink/70">{t.nori.posesNote}</p>
          </Reveal>
        </div>
      </div>
    </Section>
  );
}
